"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.currencyFormat = exports.formatUrl = void 0;
const formatUrl = (url) => (url ? (url.match(/^https?:\/\//) ? url : `https://${url}`) : null);
exports.formatUrl = formatUrl;
// tslint:disable:no-magic-numbers
const currencyFormat = (input, precision = 2) => {
    if (isNaN(input) || input === null) {
        return '-';
    }
    let value = input;
    if (typeof value === 'string') {
        value = parseInt(value, 10);
    }
    if (value >= 1000000000) {
        return '$' + Number((Math.round(value / 10000000) / 100).toFixed(precision)).toLocaleString() + 'B';
    }
    else if (value >= 1000000) {
        return '$' + Number((Math.round(value / 10000) / 100).toFixed(precision)).toLocaleString() + 'M';
    }
    else if (value > 999) {
        return '$' + Number(Math.round(value / 1000).toFixed(precision)).toLocaleString() + 'K';
    }
    else {
        return '$' + value.toFixed(precision); // if value < 1000, nothing to do
    }
};
exports.currencyFormat = currencyFormat;
// tslint:enable:no-magic-numbers
//# sourceMappingURL=string-format-utils.js.map